export default __webpack_public_path__ + "static/media/rupeesIcon.2d2682c5.svg";